import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import moment from 'moment';

import * as helpers from './reportHelpers';

import messages from './assessmentCycleTableMessages';
import LoadMore from './LoadMore';

const AssessmentCycleTable = (props) => {
  const [limit, setLimit] = useState(props.limit);
  return (
    <div className="card">
      <div className="card-body">
        <div className="card-title mb-3">
          <i className="pe-7s-graph1 mr-2" />
          {props.title ? props.title : props.intl.formatMessage(messages.title)}
        </div>
        <table className="default-table">
          <thead className="text-center">
            <tr>
              <th>{props.intl.formatMessage(messages.applications)}</th>
              <th>
                {props.isStudentTRI
                  ? props.intl.formatMessage(messages.applicationAbbreviation)
                  : props.intl.formatMessage(messages.performance)}
              </th>
              {!props.isStudentTRI && <th>{props.intl.formatMessage(messages.schoolCriteria)}</th>}
            </tr>
          </thead>
          <tbody>
            {props.items.slice(0, limit).map((item) => (
              <tr>
                <td className="align-middle text-left">
                  <div
                    style={{ height: '0px', cursor: 'pointer', color: '#ea654b' }}
                    onClick={() =>
                      props.history.push(
                        `/student-simulated/${item.idEvaluation}?idCSchool=${props.idCSchool}&idESCourse=${props.idESCourse}&idESUser=${props.idESUser}`,
                      )
                    }
                  >
                    <strong>{item.semester}</strong>
                  </div>
                  <br />
                  <span className="small">
                    {`${props.intl.formatMessage(messages.appliedIn)}: ${moment(
                      Date.parse(item.applicationDate),
                    ).format('DD/MM/YYYY')}`}
                  </span>
                </td>
                <td className="align-middle pl-0">
                  <div className="progress-wrapper border-left border-secondary">
                    {props.isStudentTRI ? (
                      <div className="progress bg-white rounded-0 in-viewport">
                        <div
                          className="progress-bar rounded-right"
                          style={{
                            width: `${item.percentageHit / 10}%`,
                            backgroundColor: helpers.getColorTRI(item.percentageHit),
                          }}
                        />
                        <span
                          style={{
                            color: helpers.getColorTRI(item.percentageHit),
                            paddingLeft: '5px',
                          }}
                        >
                          {item.percentageHit}
                        </span>
                      </div>
                    ) : (
                      <div className="progress bg-white rounded-0 in-viewport">
                        <div
                          className="progress-bar rounded-right"
                          style={{
                            width: `${item.percentageHit}%`,
                            backgroundColor: helpers.getColor(item.percentageHit),
                          }}
                        />
                        <span
                          style={{
                            color: helpers.getColor(item.percentageHit),
                            paddingLeft: '5px',
                          }}
                        >
                          {`${item.percentageHit}%`}
                        </span>
                      </div>
                    )}
                  </div>
                </td>
                {!props.isStudentTRI && (
                  <td className="align-middle text-center">{item.gradeHit}</td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
        {props.items && props.items.length > 10 ? (
          <LoadMore onClick={() => setLimit(limit + props.limit)} />
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

AssessmentCycleTable.defaultProps = {
  limit: 10,
};
export default injectIntl(AssessmentCycleTable);
